import { render } from "./StatisticPartnersIncomes.vue?vue&type=template&id=76512d78&scoped=true&ts=true"
import script from "./StatisticPartnersIncomes.vue?vue&type=script&lang=ts"
export * from "./StatisticPartnersIncomes.vue?vue&type=script&lang=ts"

import "./StatisticPartnersIncomes.vue?vue&type=style&index=0&id=76512d78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76512d78"]])

export default __exports__